import { render, staticRenderFns } from "./registGuide.vue?vue&type=template&id=6d95b89a"
import script from "./registGuide.vue?vue&type=script&lang=js"
export * from "./registGuide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports